/* eslint-disable */
export const INTEGRATION_LIB_ERROR = {
    GENERAL: 'general',
    INVALID_CARD_NUMBER: 'invalid-card-number',
    INVALID_CARD_CVV: 'invalid-card-cvv',
    INVALID_CARD_EXPIRATION: 'invalid-card-expiration',
    CARD_EXPIRED: 'card-expired',
    INVALID_CARDHOLDER: 'invalid-cardholder',
};

export const mapIntegrationLibError = (error) => {
    const {
        attribute,
        key,
    } = error;

    switch ([attribute, key].join('.')) {
    case 'integration_key.errors.configuration':
    case 'integration_key.errors.system':
        return INTEGRATION_LIB_ERROR.GENERAL;

    case 'number.errors.blank':
    case 'number.errors.invalid':
        return INTEGRATION_LIB_ERROR.INVALID_CARD_NUMBER;

    case 'cvv.errors.blank':
    case 'cvv.errors.invalid':
        return INTEGRATION_LIB_ERROR.INVALID_CARD_CVV;

    case 'month.errors.blank':
    case 'month.errors.invalid':
    case 'year.errors.blank':
    case 'year.errors.invalid':
        return INTEGRATION_LIB_ERROR.INVALID_CARD_EXPIRATION;

    case 'year.errors.expired':
        return INTEGRATION_LIB_ERROR.CARD_EXPIRED;

    case 'card_holder.errors.blank':
        return INTEGRATION_LIB_ERROR.INVALID_CARDHOLDER;

    default:
        return INTEGRATION_LIB_ERROR.GENERAL;
    }
};
